import React from 'react';

const DangerCircleSvg = ({ className }: { className?: string }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <g clipPath="url(#clip0_4090_11076)">
      <path d="M27.3152 4.6848C21.0688 -1.5616 10.9312 -1.5616 4.6848 4.6848C-1.5616 10.9312 -1.5616 21.0688 4.6848 27.3152C10.9312 33.5616 21.0688 33.5616 27.3152 27.3152C33.5616 21.0688 33.5616 10.9312 27.3152 4.6848Z" fill="currentColor" />
      <path d="M17.8262 23.1514C17.8262 24.1498 16.9899 24.9818 15.9958 24.9818C15.0016 24.9818 14.1654 24.1455 14.1654 23.1514C14.1654 22.1572 14.9718 21.321 15.9958 21.321C17.0198 21.321 17.8262 22.1274 17.8262 23.1514ZM17.6896 8.79405L17.6896 18.0356C17.6896 19.1151 16.9088 19.8148 15.9915 19.8148C15.0742 19.8148 14.2678 19.1151 14.2678 18.0356L14.2678 8.79405C14.2678 7.71458 15.0486 7.01484 15.9915 7.01484C16.9344 7.01484 17.6896 7.71458 17.6896 8.79405Z" fill="white" />
    </g>
  </svg>
);

export default DangerCircleSvg;
